<template>
    <div class="collection-point-design-container">
        <!-- 采集点树 -->
        <div class="tree-container">
            <me-tree
                ref="myTree"
                :treeData="treeData"
                :treeLoading="treeLoading"
                :treeToolBar="treeToolBar"
                :defaultProps="defaultProps"
                :nodeKey="'point_id'"
                :defaultExpandedKeys="defaultExpandedKeys"
                @handleAddTreeNode="handleAddTreeNode"
                @handleEditTreeNode="handleEditTreeNode"
                @handleDelTreeNode="handleDelTreeNode"
                @handleTreeNodeClick="handleTreeNodeClick"
            ></me-tree>
        </div>
        <!-- 右侧采集点信息回显 -->
        <div class="tree-form-wrap">
            <el-form
                v-show="treeSelect.point_id"
                ref="addComForm"
                label-width="150px"
                :rules="addComRules"
                :model="addComForm"
            >
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="采集点名称" prop="point_name">
                            <el-input
                                disabled="disabled"
                                v-model="addComForm.point_name"
                                autocomplete="off"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="安装位置" prop="position">
                            <el-input
                                disabled="disabled"
                                v-model="addComForm.position"
                                autocomplete="off"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="户号" prop="account_name">
                            <el-input
                                disabled="disabled"
                                v-model="addComForm.account_name"
                                autocomplete="off"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="采集频率" prop="collect_frequency">
                            <el-input
                                disabled="disabled"
                                v-model="addComForm.collect_frequency_name"
                                autocomplete="off"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="表号" prop="factory_no">
                            <el-input
                                disabled="disabled"
                                v-model="addComForm.factory_no"
                                autocomplete="off"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <!-- 开关099 红外095 门磁096 水侵097 烟感098 -->
            <template
                v-if="addComForm.point_class_id == '099' || addComForm.point_class_id == '095' || addComForm.point_class_id == '096' || addComForm.point_class_id == '097' || addComForm.point_class_id == '098'"
            >
                <el-table
                    border
                    style="width: 100%"
                    :data="switchData"
                    class="leader-style-table"
                    :key="certinfoKey"
                >
                    <el-table-column label="数据项" property="column_name"></el-table-column>
                    <el-table-column label="1" property="switch1_name"></el-table-column>
                    <el-table-column label="0" property="switch0_name"></el-table-column>
                </el-table>
            </template>
            <!-- 保护动作005 -->
            <template v-else-if="addComForm.point_class_id == '005'">
                <el-table
                    border
                    style="width: 100%"
                    :data="protectData"
                    class="leader-style-table"
                    :key="certinfoKey"
                >
                    <el-table-column label="数据项" property="column_name"></el-table-column>
                    <el-table-column label="保护动作" property="protect"></el-table-column>
                </el-table>
            </template>
            <!-- 电001  水002  温湿度003 漏电004 -->
            <template
                v-else-if="addComForm.point_class_id == '001' || addComForm.point_class_id == '002' || addComForm.point_class_id == '003' || addComForm.point_class_id == '004' || addComForm.point_class_id == '1658026900632879104' || addComForm.point_class_id == '1689906136465186816'" 
            >
                <el-table
                    border
                    :data="tableData"
                    class="leader-style-table"
                    height="85%"
                    :key="certinfoKey"
                >
                    <el-table-column width="50" align="center" label="序号">
                        <template slot-scope="scope">
                            <span>{{ scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="数据项" prop="column_name" align="center"></el-table-column>
                    <el-table-column label="分类" prop="kind_name" align="center"></el-table-column>
                    <el-table-column label="二次变比" prop="column_rate" align="center"></el-table-column>
                    <el-table-column label="排序" prop="seq_num" align="center"></el-table-column>
                    <el-table-column label="中文名称" prop="column_desc" align="center"></el-table-column>
                    <el-table-column label="单位" prop="column_unit" align="center"></el-table-column>
                    <el-table-column label="颜色" prop="column_color" align="center"></el-table-column>
                </el-table>
            </template>
        </div>
        <!--  :parentName="parentName" -->
        <me-collection-point-add
            :treeId="treeSelect.point_id"
            :treePId="treeSelect.p_point_id"
            :dialogType="dialogType"
            :parentPointClassId="parentPointClassId"
            @collectionPointAddCb="collectionPointAddCb"
            :dialogFormVisible.sync="dialogFormVisible"
        ></me-collection-point-add>
    </div>
</template>
<script>
import Tree from "@/comon/components/tree.vue";
import CollectionPointAdd from "./components/collection-point-add";
import * as api from "@/http/collection-point-design.js";
import { getPointList } from "@/http/api.js";
export default {
    components: {
        "me-tree": Tree,
        "me-collection-point-add": CollectionPointAdd
    },
    data() {
        return {
            treeData: [],
            treeLoading: false,
            treeSelect: {}, //选中节点
            dialogFormVisible: false,
            dialogType: "add",
            addComForm: {
                point_name: "",
                position: "",
                unit: "",
                number: "",
                frequency: ""
            },
            addComRules: {},
            defaultProps: {
                children: "childList",
                label: "point_name"
            },
            defaultExpandedKeys: [],
            // parentName: "",
            tableData: [],
            switchData: [],
            protectData: [],
            certinfoKey: true
        };
    },
    mounted() {
        this.getPointList();
    },
    methods: {
        /**
         * 获得采集点树列表
         */
        getPointList() {
            this.treeLoading = true;
            getPointList().then(res => {
                if (res && res.error_code === "0") {
                    this.treeData = res.bus_json;
                    if (!this.treeSelect.point_id) {
                        this.$refs.myTree.handleNodeClick(res.bus_json[0]);
                    } else {
                        this.$refs.myTree.handleNodeClick(this.treeSelect);
                    }
                }
                this.treeLoading = false;
            });
        },
        tickMenuIdFilter: function () {
            let resultArr = new Array();
            let getTickMenuId = function (obj) {
                if (
                    undefined === obj ||
                    null === obj ||
                    !(obj instanceof Object)
                ) {
                    return;
                }
                if (obj.status > 0) {
                    obj.disabled = true;
                    resultArr.push(obj.id);
                }
                if (null != obj.childList && obj.childList instanceof Array) {
                    for (let child of obj.childList) {
                        getTickMenuId(child);
                    }
                }
            };

            return {
                filter: function (arr) {
                    if (!(arr instanceof Array)) {
                        return false;
                    }
                    resultArr = new Array();
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return resultArr;
                }
            };
        },

        /**
         * 树新增
         * params {object} 选中节点
         */
        handleAddTreeNode(select) {
            // if (select.treeLevel == 3) {
            //     this.$message({
            //         message: "层级最多为三级！",
            //         type: "warning"
            //     });
            //     return;
            // }
            if (!select.point_id) {
                this.$message({
                    message: "请先选择节点后，再进行新增操作！",
                    type: "warning"
                });
            } else {
                this.$nextTick(() => {
                    this.treeSelect = select;
                    this.defaultExpandedKeys = [select.point_id];
                    // this.parentName = select.point_name;
                    this.dialogType = "add";
                    this.dialogFormVisible = true;
                    this.parentPointClassId = select.point_class_id;
                });
            }

            //请求接口。。。。
        },
        /**
         * 树修改
         * params {object} 选中节点
         */
        handleEditTreeNode(select) {
            if (!select.point_id) {
                this.$message({
                    message: "请先选择节点后，再进行新增操作！",
                    type: "warning"
                });
            } else {
                console.log("ssss: ", select);
                if (select.p_point_id == null || select.p_point_id == "") {
                    this.$message({
                        message: "根节点不能修改",
                        type: "warning"
                    });
                    return;
                }
                this.dialogType = "edit";
                this.treeSelect = select;
                this.defaultExpandedKeys = [select.point_id];
                this.dialogFormVisible = true;
                // this.parentName = this.getEditParentName(select.p_point_id);
            }
        },
        /**
         * 点击修改获取父节点名称
         */
        // getEditParentName(PId) {
        //     let arr = [];
        //     this.format(this.treeData, arr);
        //     return arr.filter(item => item.point_id === PId)[0].point_name;
        // },
        format(arr, newArr) {
            for (let i = 0; i < arr.length; i++) {
                newArr.push(arr[i]);
                if (arr[i].childList && arr[i].childList.length > 0) {
                    this.format(arr[i].childList, newArr);
                }
            }
            return newArr;
        },
        /**
         * 树删除
         * params {object} 选中节点
         */
        handleDelTreeNode(select) {
            if (!select.point_id) {
                this.$message({
                    message: "请先选择节点后，再进行新增操作！",
                    type: "warning"
                });
                return;
            }
            this.treeSelect = select;
            this.defaultExpandedKeys = [select.point_id];
            //模拟请求接口
            this.$confirm("确认删除该条数据？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    api.delPointDesign({
                        point_id: this.treeSelect.point_id
                    }).then(res => {
                        if (res && res.error_code === "0") {
                            this.treeSelect = {};
                            this.defaultExpandedKeys = [];
                            this.$message({
                                type: "success",
                                message: "删除成功!"
                            });
                            this.getPointList();
                        }
                    });
                })
                .catch(() => {
                    this.treeLoading = false;
                });
        },
        /**
         * 树点击
         * params {object} 选中节点
         */
        handleTreeNodeClick(select) {
            this.treeSelect = select;
            this.defaultExpandedKeys = [select.point_id];
            this.getInfoById(select);
        },
        /**
         * 获取节点信息
         * params {selectId<String>}  选中树节点ID
         */
        getInfoById(selectId) {
            api.getInfoById({
                point_id: selectId.point_id
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.addComForm.point_name = res.bus_json.point_name;
                    this.addComForm.position = res.bus_json.position;
                    this.addComForm.collect_frequency_name =
                        res.bus_json.collect_frequency_name;
                    // this.addComForm.doc_name = res.bus_json.doc_name;
                    this.addComForm.account_name = res.bus_json.account_name;
                    this.addComForm.factory_no = res.bus_json.factory_no;
                    
                    this.addComForm.point_class_id =
                        res.bus_json.point_class_id;
                    this.switchData = res.bus_json.switchList;
                    this.protectData = res.bus_json.protectList;
                    this.tableData = res.bus_json.pointDesignInfos;
                    // 重新渲染el-table
                    this.certinfoKey = !this.certinfoKey;
                    this.$forceUpdate();
                }
            });
        },
        /**
         * 添加或者修改采集点回调函数
         */
        collectionPointAddCb() {
            this.dialogFormVisible = false;
            this.getPointList();
        }
    }
};
</script>
<style lang="scss">
.collection-point-design-container {
    width: 100%;
    height: 100%;
    padding: px2Rem(20px);
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    .el-select {
        width: 100%;
    }

    .dialog-footer {
        text-align: center;
    }
    .tree-container {
        width: px2Rem(280px);
        height: 100%;
        overflow: hidden;
        border-right: 1px solid #b1c7dd;
        padding-right: 20px;
        box-sizing: border-box;
    }
    .tree-form-wrap {
        width: calc(100% - #{px2Rem(280px)});
        padding: 0 px2Rem(20px) px2Rem(20px) px2Rem(20px);
        box-sizing: border-box;
    }
}
</style>
